import { onMounted, onUnmounted, ref } from "vue";
import { debounce } from "lodash";

export function useFirstScroll() {
  const firstScroll = ref(false);

  function scrollFn() {
    if (firstScroll.value) return;
    firstScroll.value = true;
  }

  onMounted(() => {
    const dom = document.querySelector(".booklet-container");
    if (dom) {
      dom.addEventListener("scroll", debounce(scrollFn, 300), true);
    }
  });

  onUnmounted(() => {
    const dom = document.querySelector(".booklet-container");
    if (dom) {
      dom.removeEventListener("scroll", debounce(scrollFn, 300), true);
    }
  });

  return { firstScroll };
}
